import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export type UnsavedChangesDialogResult = 'save' | 'discard';

@Component({
  selector: 'unsaved-changes-dialog',
  templateUrl: './unsaved-changes-dialog.component.html',
  styleUrls: []
})
export class UnsavedChangesDialogComponent {
  constructor(public dialogRef: MatDialogRef<UnsavedChangesDialogComponent>) {}
}
